<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-b">ACKNOWLEDGMENTS</span></p>
<p class="tni">A novel is never created in a vacuum, not even the vacuum of outer space. My thanks for this book’s Big Bang go first to the extraordinary men and women of the United States Navy, including Kathy Harris, James Goudreau, Robin Allen, Linda Hutton, and Jay Munninghoff. They taught me how to be (and not to be) a military officer.</p>
<p class="tx">My gratitude also goes out to the faculty and students of the Viable Paradise workshop on Martha’s Vineyard, especially James Patrick Kelly, Steven Gould, and Debra Doyle. May there always be midnight strolls to the beach to gaze at the stars. Fond thanks to the folks at the Strange Horizons workshop in New Jersey, where Mary Anne exclaimed, “Don’t tell me what happens next! Get it published so I can read it then.”</p>
<p class="tx">I am grateful to Patrick Nielsen Hayden and James D. Macdonald for making these adventures better, and to Teresa Nielsen Hayden for believing in me. Many thanks also to my agent, Jeff Kellogg, and that rainy day in a Boston bakery when we became partners. His comments and insights have been amazing.</p>
<p class="tx">Most important, thank you and much love to Wilfred and Carol McDonald, Eric McDonald, David Bruno, Brian McDonald, Stephanie Wojtowicz, Terry Berube, Terry Odell, and the spouts. Every sailor needs a port to call home, and you’ve been mine.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?0643000c